import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { OperatorUserActionsTypes } from './Actions'
import RequestState from 'Enums/RequestState'

export const fetchOperatorUserActionsChargePointLoading = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsChargePointRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUserActionsChargePointLoadingMore = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsChargePointRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchOperatorUserActionsChargePointSuccess = (
  state,
  { offset, chargePointActions, nextOffset },
) => {
  if (offset === 0) {
    return {
      ...state,
      fetchOperatorUserActionsChargePointRequestState: RequestState.SUCCEEDED,
      operatorUserActionsChargePointPaginationOffset: nextOffset,
      operatorUserActionsChargePoint: [...chargePointActions],
    }
  } else {
    return {
      ...state,
      fetchOperatorUserActionsChargePointRequestState: RequestState.SUCCEEDED,
      operatorUserActionsChargePointPaginationOffset: nextOffset,
      operatorUserActionsChargePoint: [
        ...state.operatorUserActionsChargePoint,
        ...chargePointActions,
      ],
    }
  }
}

export const fetchOperatorUserActionsChargePointFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUserActionsChargePointRequestState: requestState,
  }
}

export const resetOperatorUserActionsChargePoint = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsChargePointRequestState: RequestState.UNINITIALIZED,
    operatorUserActionsChargePoint: [],
    operatorUserActionsChargePointPaginationOffset: 0,
  }
}

export const setOperatorUserActionsPaginationOffset = (state, { offset }) => {
  return {
    ...state,
    operatorUserActionsChargePointPaginationOffset: offset,
  }
}

export const setOperatorUserActionsFilters = (state, { filters }) => {
  return {
    ...state,
    operatorUserActionsFilters: filters,
  }
}
export const fetchOperatorUserActionsChargingTokenLoading = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsChargingTokenRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUserActionsChargingTokenLoadMore = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsChargingTokenRequestState:
      RequestState.LOADING_MORE,
  }
}

export const fetchOperatorUserActionsChargingTokenSuccess = (
  state,
  { offset, chargingTokenActions, nextOffset },
) => {
  if (offset === 0) {
    return {
      ...state,
      fetchOperatorUserActionsChargingTokenRequestState: RequestState.SUCCEEDED,
      operatorUserActionsChargingTokenPaginationOffset: nextOffset,
      operatorUserActionsChargingToken: [...chargingTokenActions],
    }
  } else {
    return {
      ...state,
      fetchOperatorUserActionsChargingTokenRequestState: RequestState.SUCCEEDED,
      operatorUserActionsChargingTokenPaginationOffset: nextOffset,
      operatorUserActionsChargingToken: [
        ...state.operatorUserActionsChargingToken,
        ...chargingTokenActions,
      ],
    }
  }
}

export const fetchOperatorUserActionsChargingTokenFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUserActionsChargingTokenRequestState: requestState,
  }
}

export const resetOperatorUserActionsChargingToken = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsChargingTokenRequestState:
      RequestState.UNINITIALIZED,
    operatorUserActionsChargingToken: [],
    operatorUserActionsChargingTokenPaginationOffset: 0,
    operatorUserActionsFilters: [
      ...JSON.parse(JSON.stringify(INITIAL_STATE.operatorUserActionsFilters)),
    ],
  }
}

export const setOperatorUserActionsChargingTokenPaginationOffset = (
  state,
  { offset },
) => {
  return {
    ...state,
    operatorUserActionsChargingTokenPaginationOffset: offset,
  }
}
export const fetchOperatorUserActionsLoading = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUserActionsLoadingMore = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchOperatorUserActionsSuccess = (
  state,
  { offset, actions, nextOffset },
) => {
  if (offset === 0) {
    return {
      ...state,
      fetchOperatorUserActionsRequestState: RequestState.SUCCEEDED,
      operatorUserActionsPaginationOffset: nextOffset,
      operatorUserActions: [...actions],
    }
  } else {
    return {
      ...state,
      fetchOperatorUserActionsRequestState: RequestState.SUCCEEDED,
      operatorUserActionsPaginationOffset: nextOffset,
      operatorUserActions: [...state.operatorUserActions, ...actions],
    }
  }
}

export const fetchOperatorUserActionsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUserActionsRequestState: requestState,
  }
}
export const clearOperatorUserActions = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsRequestState: RequestState.UNINITIALIZED,
    operatorUserActions: [],
    operatorUserActionsPaginationOffset: 0,
  }
}

export const clearOperatorUserActionsFilters = (state) => {
  let filters = JSON.parse(
    JSON.stringify(INITIAL_STATE.operatorUserActionsFilters),
  )
  return {
    ...state,
    operatorUserActionsFilters: [...filters],
  }
}

export const fetchOperatorUserActionsUserLoading = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsUserRequestState: RequestState.LOADING,
  }
}
export const fetchOperatorUserActionsUserLoadingMore = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsUserRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchOperatorUserActionsUserSuccess = (
  state,
  { offset, actions, nextOffset },
) => {
  if (offset === 0) {
    return {
      ...state,
      fetchOperatorUserActionsUserRequestState: RequestState.SUCCEEDED,
      operatorUserActionsUserPaginationOffset: nextOffset,
      operatorUserActionsUser: [...actions],
    }
  } else {
    return {
      ...state,
      fetchOperatorUserActionsUserRequestState: RequestState.SUCCEEDED,
      operatorUserActionsUserPaginationOffset: nextOffset,
      operatorUserActionsUser: [...state.operatorUserActionsUser, ...actions],
    }
  }
}

export const fetchOperatorUserActionsUserFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOperatorUserActionsUserRequestState: requestState,
  }
}
export const clearOperatorUserActionsUser = (state) => {
  return {
    ...state,
    fetchOperatorUserActionsUserRequestState: RequestState.UNINITIALIZED,
    operatorUserActionsUser: [],
    operatorUserActionsUserPaginationOffset: 0,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGE_POINT_LOADING]:
    fetchOperatorUserActionsChargePointLoading,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGE_POINT_SUCCESS]:
    fetchOperatorUserActionsChargePointSuccess,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGE_POINT_FAIL]:
    fetchOperatorUserActionsChargePointFail,
  [OperatorUserActionsTypes.RESET_OPERATOR_USER_ACTIONS_CHARGE_POINT]:
    resetOperatorUserActionsChargePoint,
  [OperatorUserActionsTypes.SET_OPERATOR_USER_ACTIONS_PAGINATION_OFFSET]:
    setOperatorUserActionsPaginationOffset,
  [OperatorUserActionsTypes.SET_OPERATOR_USER_ACTIONS_FILTERS]:
    setOperatorUserActionsFilters,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGE_POINT_LOADING_MORE]:
    fetchOperatorUserActionsChargePointLoadingMore,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGING_TOKEN_LOADING]:
    fetchOperatorUserActionsChargingTokenLoading,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGING_TOKEN_SUCCESS]:
    fetchOperatorUserActionsChargingTokenSuccess,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_CHARGING_TOKEN_FAIL]:
    fetchOperatorUserActionsChargingTokenFail,
  [OperatorUserActionsTypes.RESET_OPERATOR_USER_ACTIONS_CHARGING_TOKEN]:
    resetOperatorUserActionsChargingToken,
  [OperatorUserActionsTypes.SET_OPERATOR_USER_ACTIONS_CHARGING_TOKEN_PAGINATION_OFFSET]:
    setOperatorUserActionsChargingTokenPaginationOffset,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_LOADING]:
    fetchOperatorUserActionsLoading,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_LOADING_MORE]:
    fetchOperatorUserActionsLoadingMore,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_SUCCESS]:
    fetchOperatorUserActionsSuccess,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_FAIL]:
    fetchOperatorUserActionsFail,
  [OperatorUserActionsTypes.CLEAR_OPERATOR_USER_ACTIONS]:
    clearOperatorUserActions,
  [OperatorUserActionsTypes.CLEAR_OPERATOR_USER_ACTIONS_FILTERS]:
    clearOperatorUserActionsFilters,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_USER_LOADING]:
    fetchOperatorUserActionsUserLoading,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_USER_LOADING_MORE]:
    fetchOperatorUserActionsUserLoadingMore,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_USER_SUCCESS]:
    fetchOperatorUserActionsUserSuccess,
  [OperatorUserActionsTypes.FETCH_OPERATOR_USER_ACTIONS_USER_FAIL]:
    fetchOperatorUserActionsUserFail,
  [OperatorUserActionsTypes.CLEAR_OPERATOR_USER_ACTIONS_USER]:
    clearOperatorUserActionsUser,
})
